module.exports = "/images/vendor/flag-icon-css/flags/4x3/ph.svg?12f36eed83fdf6fa33bccb7eae18286a";